<aside class="flex h-full min-h-0 w-full flex-col bg-white">
  <div class="flex shrink-0 flex-col gap-1 border-b border-slate-100 px-4 py-4">
    <div class="flex flex-wrap items-center justify-between gap-2">
      <div class="flex min-w-0 flex-wrap items-center gap-2">
        <h2 class="text-sm font-semibold text-slate-950">Action settings</h2>
        <span class="rounded-full bg-slate-100 px-2.5 py-0.5 text-xs font-medium text-slate-600">
          {{ action().label }}
        </span>
      </div>
      <button
        type="button"
        class="shrink-0 rounded-lg px-2.5 py-1.5 text-xs font-medium text-rose-600 transition hover:bg-rose-50"
        (click)="remove.emit()">
        Remove
      </button>
    </div>
    <p class="text-xs leading-5 text-slate-500">
      Configure what happens when this action runs after submit.
    </p>
  </div>

  <div class="flex min-h-0 flex-1 flex-col gap-6 overflow-y-auto px-4 py-4">
    <section class="flex flex-col gap-3">
      <h3 class="text-xs font-semibold uppercase tracking-wide text-slate-400">Configuration</h3>

      @if (isType('send_email')) {
        <lib-signal-text-field
          label="To"
          inputType="email"
          placeholder="team@company.com"
          [value]="draft()['to'] ?? ''"
          [debounceValueChange]="false"
          (valueChange)="updateConfig('to', $event)" />
        <lib-signal-text-field
          label="Subject"
          [value]="draft()['subject'] ?? ''"
          [debounceValueChange]="false"
          (valueChange)="updateConfig('subject', $event)" />
        <lib-signal-textarea
          label="Body template"
          [rows]="4"
          [value]="draft()['body'] ?? ''"
          [debounceValueChange]="false"
          (valueChange)="updateConfig('body', $event)" />
      }

      @if (isType('send_slack')) {
        <lib-signal-text-field
          label="Channel"
          placeholder="#submissions"
          [value]="draft()['channel'] ?? ''"
          [debounceValueChange]="false"
          (valueChange)="updateConfig('channel', $event)" />
        <lib-signal-textarea
          label="Message"
          [rows]="3"
          [value]="draft()['message'] ?? ''"
          [debounceValueChange]="false"
          (valueChange)="updateConfig('message', $event)" />
      }

      @if (isType('call_webhook')) {
        <lib-signal-text-field
          label="URL"
          inputType="url"
          placeholder="https://example.com/hooks/form"
          [value]="draft()['url'] ?? ''"
          [debounceValueChange]="false"
          (valueChange)="updateConfig('url', $event)" />
        <lib-signal-dropdown
          label="Method"
          [items]="methodOptions"
          valuePath="value"
          displayPath="label"
          [value]="draft()['method'] ?? 'POST'"
          [debounceValueChange]="false"
          (valueChange)="onMethodChange($event)" />
      }

      @if (isType('notify_teams')) {
        <lib-signal-text-field
          label="Teams webhook URL"
          inputType="url"
          placeholder="https://outlook.office.com/webhook/…"
          [value]="draft()['webhookUrl'] ?? ''"
          [debounceValueChange]="false"
          (valueChange)="updateConfig('webhookUrl', $event)" />
        <lib-signal-textarea
          label="Message"
          [rows]="3"
          [value]="draft()['message'] ?? ''"
          [debounceValueChange]="false"
          (valueChange)="updateConfig('message', $event)" />
      }

      @if (isType('if_else')) {
        <lib-signal-text-field
          label="Condition"
          placeholder="e.g. User Type is Support"
          [value]="draft()['condition'] ?? ''"
          [debounceValueChange]="false"
          (valueChange)="updateConfig('condition', $event)" />
      }
    </section>
  </div>
</aside>
